import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI/_Legacy'

export const Container = styled(Flex)`
  width: 100%;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const Content = styled(Flex)`
  width: 100%;
  max-width: 1180px;
  flex-direction: column;
  z-index: 10;
`

export const Block = styled(Flex)`
  background-color: ${themeGet('colors.white')};
`
